export default __webpack_public_path__ + "static/hotblack-tech-illustration-a8b0098daa96264f4d7193c0a6810b25.svg";